<div class="container__buttons">
    <mat-form-field class="input-search" appearance="outline">
        <mat-label>Filtro</mat-label>
        <input matInput (keyup)="filter($event)" maxlength="50" autocomplete="off" placeholder="digite el nombre o correo de usuario">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
</div>
<div class="container__table">
    <div class="header__table">
        <h4>Listado de usuarios</h4>

    </div>
    <div class="responsive__table">
        <table mat-table [dataSource]="this.appStateService.GetUsersResultVar && this.appStateService.GetUsersResultVar.userList || []">
            <!-- Nombre Column -->
            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef> Nombre </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>
            <!-- Correo Column -->
            <ng-container matColumnDef="correo">
                <th mat-header-cell *matHeaderCellDef> Correo </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>
            <!-- Acceso Column -->
            <ng-container matColumnDef="acceso">
                <th mat-header-cell *matHeaderCellDef> Acceso </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="example-form">
                        <div style="display: flex; flex-direction: column; min-width: 250px; gap: 5px;">
                            <mat-checkbox [checked]="element.hasCompanyAccess" (change)="canAccesC(element)">Puede ingresar a esta empresa</mat-checkbox>
                            <mat-checkbox [checked]="element.isAdmin" (change)="canManagP(element)">Puede administrar permisos</mat-checkbox>
                            <ng-container *ngIf="isDisabled(element)">
                                <button class="df-primario df-btn-xl" style="min-width: 60px; width: 115px; height: 35px; font-size: 12px; text-align: center;" (click)="onFormSubmit(element)">Guardar cambios</button>
                            </ng-container>
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- Tres puntos Column -->
            <ng-container matColumnDef="menu" stickyEnd>
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                    <mat-menu #appMenu="matMenu">
                        <button mat-menu-item (click)="PasswordChangeAdmin(element)">
                            <mat-icon>manage_accounts</mat-icon> Reiniciar contraseña
                        </button>
                        <button matTooltip="Eliminar métodos de autenticación multi factor" mat-menu-item (click)="RemoveAllTwoFactorComponent(element)">
                            <mat-icon>manage_accounts</mat-icon> Eliminar métodos de autenticación multi factor
                        </button>
                        <button matTooltip="Asignar acceso a todas las empresas de esta suite" mat-menu-item (click)="SetAllCompanyAccessAsyncComponent(element)">
                            <mat-icon>manage_accounts</mat-icon>  Asignar acceso a todas las empresas de esta suite
                        </button>
                        <button mat-menu-item (click)="ModifiedUser(element)">
                            <mat-icon>manage_accounts</mat-icon>  Modificar información
                        </button>
                    </mat-menu>
                    <button mat-icon-button [matMenuTriggerFor]="appMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                    <div class="not__found">
                        <div class="container__img">
                            <img src="assets/media/svg/buscar.svg">
                        </div>
                        <div class="container-label">
                            <p>No hemos encontrado ningún resultado que coincida con tu búsqueda</p>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <app-list-paginator [listado]="2"></app-list-paginator>
</div>